module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header_2-ddc49b1012f51a2e260635673535a33a.webp";